module.exports = __webpack_public_path__ + "static/logo_white-98569fe52117f6de860263ba6f62ac8f.png";